module.exports = __webpack_public_path__ + "static/YoClock1-d6597279ab872ce5d376570595828334.png";